/**
 * @Description 弹幕类
 * @Author dandan
 * @Date 2020-12-22
 * @Version 1.0
 */
const defaultAvator = require('@/assets/img/pictures/wx_avatar.jpg')
class Barrage {
  static init (canvas) {
    return new Barrage(canvas)
  }

  /**
   * Barrage类构造函数
   * @param {DOM} canvas canvas的DOM对象
   * @returns {Barrage} 返回单例对象
   */
  constructor (canvas) {
    /**
     * @type {canvas.ctx} canvas上下文
      */
    this.ctx = canvas.getContext('2d')
    /**
     * @type {boolean} 控制是否允许刷新canvas(是否允许播放)
     */
    this.isPlay = false
    /**
     * @type {string} canvs字体样式
     */
    this.ctx.font = '20px Microsoft YaHei'
    /**
     * @type {string} 阴影颜色
     */
    // this.ctx.shadowColor = '#000000'
    /**
     * @type {number} 阴影模糊
     */
    // this.ctx.shadowBlur = 5
    /**
     * @type {number} 阴影水平偏移
     */
    // this.ctx.shadowOffsetX = 1
    /**
     * @type {number} 阴影垂直偏移
     */
    // this.ctx.shadowOffsetY = 1
    /**
     * @type {DOMRect} canvas元素距离视口的位置
     */
    this.rect = canvas.getBoundingClientRect()
    /**
     * @type {number} canvas元素的长宽
     */
    this.w = this.rect.right - this.rect.left
    this.h = this.rect.bottom - this.rect.top
    /**
       *  @bulletInfo {
       *    value:string  文字信息
       *    top:number    弹幕距离canvas顶部距离
       *    left:number   弹幕现时位置(距离canvas左部距离)
       *    color:string  弹幕颜色
       *    speed:number  弹幕移动的速度
       *    width:number  弹幕自身的宽度
       *    avatar:string 头像的src
       *  }
       *  @type {Array<bulletInfo>} 弹幕的信息列表
       *
       */
    this.barrageList = []
    /**
     * @type {boolean} 标记当前回调函数是否正在执行
    */
    this.isCalling = false
    /**
     * @type {number} 记录当前正在shoot的弹幕数量
    */
   this.isShooting = 0
  }

  // 添加弹幕列表
  shoot ({
    value,
    speed = 3,
    avatarUrl,
    offsetLeft,
    bulletPkId
  }) {
    this.isShooting++
    const that = this
    const top = this.getTop()
    const width = Math.ceil(this.ctx.measureText(value).width) + 30
    const avatar = new Image()
    avatar.src = avatarUrl
    avatar.onload = function () {
      //排他
      if(!that.barrageList.some(item => item.bulletPkId === bulletPkId) || bulletPkId === -1){
        const bulletInfo = {
          bulletPkId:bulletPkId,
          value: value,
          top: top,
          left: that.w + (offsetLeft || 0),
          color: '#333',
          speed: speed,
          width: width,
          avatar: avatar
        }
        that.barrageList.push(bulletInfo)
        that.isShooting--
      }
    }
    avatar.onerror = function(){
      avatar.src = defaultAvator
      if(!that.barrageList.some(item => item.bulletPkId === bulletPkId) || bulletPkId === -1){
        const bulletInfo = {
          bulletPkId:bulletPkId,
          value: value,
          top: top,
          left: that.w + (offsetLeft || 0),
          color: '#333',
          speed: speed,
          width: width,
          avatar: avatar
        }
        that.barrageList.push(bulletInfo)
        that.isShooting--
      }
    }
  }

  // 开始绘制
  draw () {
    if (!this.isPlay) {
      this.ctx.clearRect(0, 0, this.w, this.h)
      return
    }
    if (this.barrageList.length) {
      this.ctx.clearRect(0, 0, this.w, this.h)
      for (let i = 0; i < this.barrageList.length; i++) {
        const b = this.barrageList[i]
        if (b.left + b.width < 0) {
          this.barrageList.splice(i,1)
          i--
          continue
        }
        b.left -= b.speed
        this.drawText(b)
      }
      //弹幕列表长度不足
      if (this.barrageList.length < 5 && !this.isCalling){
        this.isCalling = true
        this.barrageListAlmostEmptyCb()
        .catch(()=>{
          this.isCalling = false
        })
        .finally(()=>{
          this.isCalling = false
        })
      }
    } else {
      //弹幕列表长度为0,暂停播放
      // this.allowPlay(false)
    }
    // console.log("==================弹幕移动中============");
    setTimeout(this.draw.bind(this), 33)
    // requestAnimationFrame(this.draw.bind(this));
  }

  // 绘制单个弹幕
  drawText (bulletInfo) {
    // 绘制框
    this.ctx.beginPath()
    this.ctx.arc(bulletInfo.left + 13, bulletInfo.top - 20 + 13, 14, Math.PI * 0.5, Math.PI * 1.5, false)
    this.ctx.lineTo(bulletInfo.left + bulletInfo.width - 8, bulletInfo.top - 20 + 13 - 14)
    this.ctx.arc(bulletInfo.left + bulletInfo.width - 8, bulletInfo.top - 20 + 13, 14, Math.PI * 1.5, Math.PI * 0.5, false)
    this.ctx.closePath()
    this.ctx.fillStyle = 'rgba(255,255,255,0.5)'
    this.ctx.fill()
    // 绘制用户头像
    this.ctx.save()
    this.ctx.beginPath()
    this.ctx.arc(bulletInfo.left + 13, bulletInfo.top - 20 + 13, 13, 0, Math.PI * 2, false)
    this.ctx.clip()
    this.ctx.drawImage(bulletInfo.avatar, bulletInfo.left, bulletInfo.top - 20, 26, 26)
    this.ctx.restore()
    // 绘制文字
    this.ctx.fillStyle = bulletInfo.color
    this.ctx.fillText(bulletInfo.value, bulletInfo.left + 30, bulletInfo.top)
  }

  // 获取随机top
  getTop () {
    // canvas绘制文字x,y坐标是按文字左下角计算，预留23px
    return Math.floor(Math.random() * (Math.floor(this.h / 26) -1)) * 26 + 23
    // return Math.floor(Math.random() * (this.h - 26)) + 23
  }

  // 允许刷新(允许播放)
  allowPlay (allow) {
    this.isPlay = allow
  }

  // 弹幕列表为空时的回调函数
  listenBarrageListAlmostEmpty(cb){
    this.barrageListAlmostEmptyCb = cb
  }
}

export {
  Barrage
}
